
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/pelaksanaan/dokumen-persiapan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/pelaksanaan/dokumen-persiapan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/pelaksanaan/dokumen-persiapan"])
      });
    }
  